module.exports = __webpack_public_path__ + "static/assets/fdd54a97b81b3e4cb4a759e9219b950a.png";